import React from 'react';
import { Value } from './types';

export const AnalyticsContext = React.createContext<Value>({
  pageloadId: '',
  setUtmParameters() {
    throw new Error(errorMessage);
  },
  sendPageloadAnalytics() {
    throw new Error(errorMessage);
  },
});

const errorMessage = "Analytics context doesn't have a Provider";
